import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import { parse } from 'date-fns'

export interface DestinyFine {
  feeId: number
  description: string
  date: Date
  datetime: string
  amountDue: number
  allowPartial: boolean
  feeCategory: string
  type: string
}

export const destinyFines = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get('/ajax/student/' + studentAccountId + '/destiny_fines')
  return Util.Obj.keysToCamel(response.data.destiny_fines).map((fee: any) => ({
    ...fee,
    date: parse(fee.date, 'yyyy-MM-dd', new Date())
  })) as DestinyFine[]
}
